import React from "react";
import { BarChart3, FileText, BookOpen, Check } from "lucide-react";

const ITEMS = [
  {
    icon: BarChart3,
    title: "Visibility Score™",
    body:
      "A percentage-based score measuring your school's visibility across five dimensions.",
  },
  {
    icon: FileText,
    title: "Visibility Report™",
    body:
      "A personalized report highlighting strengths, opportunities, and practical recommendations.",
  },
  {
    icon: BookOpen,
    title: "School Visibility Playbook™",
    body:
      "A collection of practical ideas and strategies used by schools to improve communication, recognition, and engagement.",
  },
];

const INSIGHTS = [
  "Student accomplishments may not be receiving consistent visibility.",
  "School events may be under-promoted.",
  "Teachers may have limited access to communication tools.",
  "School culture may not be fully reflected throughout the building.",
  "Opportunities may exist to strengthen recognition and engagement.",
];

export default function VCReceive() {
  return (
    <section
      data-testid="vc-receive-section"
      className="bg-white py-24 md:py-32 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-14 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            What you'll receive
          </div>
          <h2
            data-testid="vc-receive-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
          >
            Three Resources Built for{" "}
            <span className="text-teal">School Leaders.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6 mb-16">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                data-testid={`vc-receive-item-${i}`}
                className="group bg-[#F4F6F4] hover:bg-white border border-slate-200 hover:border-teal/40 rounded-2xl p-8 transition-all duration-300 hover:shadow-md flex flex-col"
              >
                <div className="cmyk-ribbon h-1 w-12 mb-6 rounded-full" aria-hidden />
                <div className="w-14 h-14 rounded-xl bg-navy text-white flex items-center justify-center mb-6 group-hover:bg-teal transition-colors">
                  <Icon className="w-6 h-6" strokeWidth={2} />
                </div>
                <h3 className="font-serif text-xl md:text-2xl font-bold text-navy mb-3 leading-tight">
                  {it.title}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed">
                  {it.body}
                </p>
              </div>
            );
          })}
        </div>

        <div className="bg-[#F4F6F4] border border-slate-200 rounded-2xl p-8 md:p-12 max-w-4xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            Sample insights
          </div>
          <p className="font-serif text-lg sm:text-xl font-bold text-navy mb-6 leading-snug">
            Examples of findings participants may uncover:
          </p>
          <ul className="space-y-3">
            {INSIGHTS.map((ins, i) => (
              <li
                key={ins}
                data-testid={`vc-insight-${i}`}
                className="flex items-start gap-3"
              >
                <span className="flex-shrink-0 mt-1 w-5 h-5 rounded-full bg-teal/20 border border-teal/40 flex items-center justify-center">
                  <Check className="w-3 h-3 text-teal" strokeWidth={3} />
                </span>
                <span className="text-sm sm:text-base text-slate-700 leading-relaxed">
                  {ins}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
